import cx from "classnames";
import { Button, Modal, FlexBox, Card, Image } from "components";
import React from "react";
import { useGetUserDetailsApiDetails, setGeneralDetails } from "Slices";
import { nameFunctions } from "utils";
import "./styles.scss";
import { OrganisationSelectionModalProps } from "./types";
import CrossIcon from "assets/icons/cross.svg";
const OrganisationSelectionModal: React.FC<OrganisationSelectionModalProps> = ({
  visible,
  showCross,
  onClose,
}) => {
  const userDetails = useGetUserDetailsApiDetails();

  return (
    <Modal
      modalHeader={""}
      onClose={onClose}
      visible={visible}
      className="organisation-selection-modal"
    >
      <FlexBox flexColumn justifyCenter alignCenter className="h-100 w-100">
        {showCross && (
          <Image
            src={CrossIcon}
            className="cross-icon curs-point clicking-animation"
            onClick={onClose}
          />
        )}
        <p className="fs-32 font-heavy">Select Organisation</p>
        <FlexBox justifyEvenly alignCenter className="w-100" flexWrap>
          {userDetails?.data?.organizations?.map((item: any, index: number) => {
            return (
              <Card
                className="w-23 mr-t-40 clicking-animation curs-point"
                key={`organisation-list-${item.companyName}-${index}`}
                onClick={() => {
                  setGeneralDetails({
                    selectedOrganisation: { ...item },
                  });
                  localStorage.setItem("organisationID", item.id);
                  localStorage.setItem("organisationIndex", `${index}`);
                  onClose();
                  showCross && window.location.reload();
                }}
              >
                <FlexBox flexColumn justifyCenter alignCenter>
                  <FlexBox
                    justifyCenter
                    alignCenter
                    className="icon-name fs-22 font-heavy"
                  >
                    {nameFunctions.getIconName(item.companyName)}
                  </FlexBox>
                  <p className="fs-24 font-medium uppercase mr-t-10">
                    {item.companyName}
                  </p>
                </FlexBox>
              </Card>
            );
          })}
        </FlexBox>
      </FlexBox>
    </Modal>
  );
};
export default OrganisationSelectionModal;
